import { DefaultButton, Label, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, Stack, Toggle } from "office-ui-fabric-react";
import * as React from "react";
import { saveSettings } from "../../../api/settings";
import { ProfileContext } from "../../../Home";
import { IBookingConstraint } from "../../../types/Booking.types"
import { IGlobalSettings } from "../../../types/Settings.types";
import { RestrictionsSection, RestrictionUpdate } from "./RestrictionsSection";

export interface IGlobalSettingsFormProps {
    onDismiss: () => void;
}

export const GlobalSettingsForm = (props: IGlobalSettingsFormProps) => {

    const profileContext = React.useContext(ProfileContext);

    const [ maintenanceMode, setMaintenanceMode ] = React.useState(profileContext?.Settings.MaintenanceMode || false);
    const [ roomBookingEnabled, setRbEnabled ] = React.useState(profileContext?.Settings.RoomBookingEnabled || false);
    const [ deskBookingEnabled, setDbEnabled ] = React.useState(profileContext?.Settings.DeskBookingEnabled || false);
    const [ deskConstraint, setDeskConstraint ] = React.useState<IBookingConstraint|undefined>(profileContext?.Settings.GlobalDeskConstraint);
    const [ roomConstraint, setRoomConstraint ] = React.useState<IBookingConstraint|undefined>(profileContext?.Settings.GlobalRoomConstraint);
    const [ error, setError ] = React.useState<string>();

    const _saveSettings = React.useCallback(async () => {
        const saveObj = {
            MaintenanceMode: maintenanceMode,
            RoomBookingEnabled: roomBookingEnabled,
            DeskBookingEnabled: deskBookingEnabled,
            GlobalDeskConstraint: deskConstraint,
            GlobalRoomConstraint: roomConstraint,
        } as IGlobalSettings;
        const response = await saveSettings(saveObj);
        if (response instanceof Error) {
            setError(response.message);
        } else {
            profileContext?.onProfileUpdated(new AbortController());
            props.onDismiss();
        }
    }, [deskConstraint, roomConstraint, maintenanceMode, deskBookingEnabled, roomBookingEnabled, props, profileContext]);

    return (
        <Panel type={PanelType.medium} headerText="Global Settings" isOpen={true} onDismiss={props.onDismiss}
            onRenderFooter={() => (
                <Stack styles={{root: { margin: 20 }}} horizontal horizontalAlign="end" tokens={{childrenGap: 10}}>
                    <DefaultButton text="Cancel" onClick={() => props.onDismiss() }/>
                    <PrimaryButton text="Save" onClick={() => _saveSettings()} />
                </Stack>
            )}
        >
            { Boolean(error) === true && (
                <MessageBar messageBarType={MessageBarType.error}>
                    { error }
                </MessageBar>
            ) }
            { Boolean(error) === false && (
                <>
                    <MessageBar messageBarType={MessageBarType.info}>
                        When the site is in Maintenance Mode, users will still be able to access the site - but they will be prevented from making any further bookings.
                    </MessageBar>
                    <Toggle label="Maintenance Mode" checked={maintenanceMode} onText="On" offText="Off" onChange={(e, checked) => setMaintenanceMode(checked || false)} />
                    <Label>Enable / Disable Features:</Label>
                    <Toggle label="Room Booking" onText="Yes" offText="No" checked={roomBookingEnabled} onChange={(e, checked) => setRbEnabled(checked !== undefined ? checked : true)} />
                    <Toggle label="Desk Booking" onText="Yes" offText="No" checked={deskBookingEnabled} onChange={(e, checked) => setDbEnabled(checked !== undefined ? checked : true)} />
                    <RestrictionsSection
                        resourceId={-1}
                        onChange={(constraints) => {
                            setDeskConstraint(constraints.deskBookingConstraint);
                            setRoomConstraint(constraints.roomBookingConstraint);
                        }}
                        updateType={RestrictionUpdate.Global}
                        deskBookingConstraint={deskConstraint}
                        roomBookingConstraint={roomConstraint}
                    />
                </>
            )}
        </Panel>
    )
}
